export default __webpack_public_path__ + "static/media/logo-2.66ba1364.png";